/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RestrictedWordUsage {
    FOLLOW_UP_MESSAGES = 'FollowUpMessages',
    AUTO_MESSAGE_EXPIRING_FANS = 'AutoMessageExpiringFans',
    ONLY_FANS_MASS_MESSAGE = 'OnlyFansMassMessage',
    BULK_MESSAGES = 'BulkMessages',
    WELCOME_MESSAGES = 'WelcomeMessages',
    ONLINE_MASS_MESSAGES = 'OnlineMassMessages',
    MASS_MESSAGES = 'MassMessages',
    DASHBOARD = 'Dashboard',
    DIRECT_MESSAGE = 'DirectMessage',
    POST_CREATION = 'PostCreation',
}
